import { render, staticRenderFns } from "./PaymentCollection.vue?vue&type=template&id=0fc6d32e"
import script from "./PaymentCollection.vue?vue&type=script&lang=ts"
export * from "./PaymentCollection.vue?vue&type=script&lang=ts"
import style0 from "./PaymentCollection.vue?vue&type=style&index=0&id=0fc6d32e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports